module.exports = __webpack_public_path__ + "img/United Arab Emirates.b5243645.gif";